module.exports = __webpack_public_path__ + "media/images/lb/017-7f4690d260c92a19f2cc315d5030f9a1.svg";